import { connect, ConnectedProps } from 'react-redux';
import { hideLoading, showLoading } from 'react-redux-loading-bar';

import { RootState } from '../../../../../../store/root-reducer';

import DoNotCallList from './do-not-call-list';

import {
  CreateDoNotCallListPayload,
  GetDoNotCallListsPayload,
  UpdateDoNotCallListPayload,
} from '../../../../types/do-not-call-list';
import {
  getDoNotCallListsRequest,
  createDoNotCallListRequest,
  updateDoNotCallListRequest,
  deleteDoNotCallListRequest,
} from '../../extra-actions';
import {
  resetGetDoNotCallListsRequest,
  resetCreateDoNotCallListRequest,
  resetUpdateDoNotCallListRequest,
  resetDeleteDoNotCallListRequest,
  resetCreatedDoNotCallListId,
} from '../../do-not-call-slice';
import { GetAgencyClientDropdownRequestPayload } from '../../../../../agency-client-management/types/request-payload';
import { getAgencyClientsDropdown } from '../../../../../agency-client-management/extra-actions';

const mapStateToProps = (state: RootState) => ({
  getDoNotCallListsRequestStatus:
    state.callDoNotContact.getDoNotCallListsRequest.status,
  getDoNotCallListsRequestError:
    state.callDoNotContact.getDoNotCallListsRequest.error,

  createDoNotCallListRequestStatus:
    state.callDoNotContact.createDoNotCallListRequest.status,
  createDoNotCallListRequestError:
    state.callDoNotContact.createDoNotCallListRequest.error,

  updateDoNotCallListRequestStatus:
    state.callDoNotContact.updateDoNotCallListRequest.status,
  updateDoNotCallListRequestError:
    state.callDoNotContact.updateDoNotCallListRequest.error,

  deleteDoNotCallListRequestStatus:
    state.callDoNotContact.deleteDoNotCallListRequest.status,
  deleteDoNotCallListRequestError:
    state.callDoNotContact.deleteDoNotCallListRequest.error,

  doNotCallLists: state.callDoNotContact.doNotCallLists,
  doNotCallListsPaginationOptions:
    state.callDoNotContact.doNotCallListsPaginationOptions,
  createdDoNotCallListId: state.callDoNotContact.createdDoNotCallListId,

  agencyClients: state.agencyClient.clients,
  agencyConfigRequestStatus: state.home?.getAgencyConfigRequest?.status,
});

const mapDispatchToProps = {
  sendGetDoNotCallListsRequest: (payload: GetDoNotCallListsPayload) =>
    getDoNotCallListsRequest(payload),
  resetGetDoNotCallListsRequest: () => resetGetDoNotCallListsRequest(),

  sendCreateDoNotCallListRequest: (payload: CreateDoNotCallListPayload) =>
    createDoNotCallListRequest(payload),
  resetCreateDoNotCallListRequest: () => resetCreateDoNotCallListRequest(),
  resetCreatedDoNotCallListId: () => resetCreatedDoNotCallListId(),

  sendUpdateDoNotCallListRequest: (payload: UpdateDoNotCallListPayload) =>
    updateDoNotCallListRequest(payload),
  resetUpdateDoNotCallListRequest: () => resetUpdateDoNotCallListRequest(),

  sendDeleteDoNotCallListRequest: (id: string) =>
    deleteDoNotCallListRequest(id),
  resetDeleteDoNotCallListRequest: () => resetDeleteDoNotCallListRequest(),

  sendGetAgencyClientsDropdownRequest: (
    payload: GetAgencyClientDropdownRequestPayload,
  ) => getAgencyClientsDropdown(payload),

  showLoading: () => showLoading(),
  hideLoading: () => hideLoading(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export default connector(DoNotCallList);
